import { Router } from '@angular/router';
import { AdalService } from 'adal-angular4';
import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/Service/login.service';
import { CommonService } from 'src/app/Service/Common.service';
import { UserDetailsViewModel } from 'src/app/ViewModel/UserDetailsModel';
import { NotificationService } from 'src/app/Service/notification.service';

@Component({
  selector: 'app-auth-callback',
  template: '<div class="k-i-loading"></div>'
})
export class AuthCallbackComponent implements OnInit {

  constructor(
    public router: Router,
    private adal: AdalService,
    private loginService: LoginService,
    private commonService: CommonService,
    private _notificationService: NotificationService) {

    this.adal.handleWindowCallback();

    if (this.adal.userInfo.authenticated === false) {
      this._notificationService.showPopup('System failure. Please try again later', "Warning").then(
        x => this.loginService.Logout(true)
      );
    }
    else {
      let user = {
        jWTtoken: this.adal.userInfo.token,
        staffPsNO: this.adal.userInfo.profile.EmployeeID,
        isInternal: true,
        isLoginTime: true
      }
      // UserDetailsViewModel[]
      this.loginService.GetCurrentUserDetails(user).subscribe((data: any) => {
        if (data["successCode"] === 200) {
          let isDuplicateLogin: any = data["isDuplicateLogin"];
          this.commonService.setCurrentUserProfileCard(data);

          if (isDuplicateLogin === true) {
            this._notificationService.showPopup('Your login account is used in another device. The session in that device has been closed', "Warning").then(
              x => {
                this.router.navigate(this.commonService.redirectUserToPRAddComments ? ['/peer-review/review-add-comments'] : ['/dashboard']);
              }
            );
          }
          else {
            this.router.navigate(this.commonService.redirectUserToPRAddComments ? ['/peer-review/review-add-comments'] : ['/dashboard']);

          }
        }
        else {
          this._notificationService.showPopup('You are not a valid member, Kindly contact your Admin/Coordinator', "Warning");
          this.router.navigate(['/authentication/login']);
        }
      });
    }
  }

  ngOnInit() {
  }

}
